export const MARKETING_AUTOMATED_CAMPAIGN_TYPE_TABS_FLAG =
  'hermes.marketingAutomatedCampaignTypeTabs'

// Gates the pre-send guard that blocks one-time campaigns whose text sections
// still contain unedited starter-template copy. Off → legacy behavior (send
// allowed), on → SendOTCDialog warns and blocks until the copy is edited.
export const MARKETING_OTC_UNEDITED_COPY_GUARD_FLAG =
  'hermes.marketing.otcUneditedCopyGuard'
